import PropTypes from 'prop-types';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Icon from '../common/Icon';
import translations from '../../translations';

const CopyToClipboardButton = ({ copyPermalink, permalink }) => {
    if (!permalink) {
        return null;
    }

    return (
        <div className="ast-app-details__footer-permalink">
            <CopyToClipboard onCopy={copyPermalink} text={permalink}>
                <button type="button" className="sg-button-link">
                    <Icon alias="link" />
                    &nbsp;<span>{translations.appDetails.linkToPage}</span>
                </button>
            </CopyToClipboard>
        </div>
    );
};

CopyToClipboardButton.propTypes = {
    permalink: PropTypes.string,
    copyPermalink: PropTypes.func.isRequired,
};

export default CopyToClipboardButton;
